<!-- Create new order-->
<mat-horizontal-stepper linear="true" #stepper>
  <!-- Step 1 formulario-->
  <mat-step [stepControl]="formRO" label="Formulario">
    <ng-container *ngTemplateOutlet="formRentalOrder"></ng-container>
  </mat-step>

  <!-- Step 2 equipos alquiler-->
  <mat-step [stepControl]="formEquipmentRental" label="Equipos">
    <form [formGroup]="formEquipmentRental">
      <ng-template matStepLabel>Equipos a Alquilar</ng-template>
      <app-handler-items
        (listItemComplete)="saveRentalEquipment($event)"
        [itemsData]="itemsData"
        [addWarehouse]="false"
        [titleDialog]="'Equipo orden alquiler'"
        [showAmount]="false"
        [showCurrentAmount]="false"
        [showUnitMeasurement]="false"
        [urlItemCombo]="urlGetEquipmentRental"
        [paramsRentalOrder]="paramsRentalOrder"
        [showDate]="false"
        [showTotal]="false"
        [openDialog]="false"
        labelCodigo="Marca"
        [showReplyButton]="false"
        [editCostItem]="true"
        [view]="disbledEquipment ? false : true"
      >
      </app-handler-items>
    </form>
  </mat-step>
</mat-horizontal-stepper>

<ng-template #formRentalOrder>
  <form
    [formGroup]="formRO"
    (ngSubmit)="formRO.valid ? this.stepper.next() : errorMessage()"
    style="overflow: auto"
  >
    <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport cdk">
      <div style="display: flex; width: 100%; margin-top: 10px">
        <div [style.flex]="data.action == 'edit' ? 10 : 12">
          <div class="first-row">
            <div class="row-item" *ngIf="data.action == 'edit'">
              <mat-form-field>
                <input
                  [value]="data.body[0].consecutive"
                  matInput
                  readonly
                  placeholder="# orden"
                />
              </mat-form-field>
            </div>

            <div class="row-item">
              <combos
                [configuration]="combosConfigClient"
                [reloadCombo]="reloadComboClient"
                [required]="true"
                [filter]="true"
                (returnDataCombo)="getDataComboProviders($event)"
                (changeOption)="ValueIDProvider($event)"
                [control]="formRO.get('providerId')"
                [disabled]="
                  isDisabled || rentalOrderState == 3 || rentalOrderState == 4
                "
              >
              </combos>
            </div>

            <div class="row-item">
              <mat-form-field>
                <input
                  autocomplete="off"
                  type="text"
                  formControlName="providerAddress"
                  matInput
                  required
                  #direccion
                  maxlength="255"
                  placeholder="Dirección"
                  [disabled]="
                    isDisabled || rentalOrderState == 3 || rentalOrderState == 4
                  "
                />
                <mat-hint>{{ direccion.value.length }}/255</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="default-row">
            <div class="row-item">
              <combos
                [configuration]="combosConfigDelivery"
                [reloadCombo]="reloadComboDelivery"
                [required]="true"
                [filter]="true"
                [control]="formRO.get('userDeliveryId')"
                [disabled]="
                  isDisabled || rentalOrderState == 3 || rentalOrderState == 4
                "
              >
              </combos>
            </div>

            <div class="row-item">
              <mat-form-field>
                <mat-label>Fecha Inicio</mat-label>
                <input
                  [matDatepicker]="pickerInicio"
                  autocomplete="off"
                  matInput
                  required
                  formControlName="startDate"
                  [disabled]="
                    isDisabled || rentalOrderState == 3 || rentalOrderState == 4
                  "
                />
                <mat-datepicker-toggle matSuffix [for]="pickerInicio">
                </mat-datepicker-toggle>
                <mat-datepicker
                  #pickerInicio
                  [touchUi]="movil ? true : false"
                ></mat-datepicker>
                <mat-error>Campo requerido</mat-error>
              </mat-form-field>
            </div>

            <div class="row-item">
              <mat-form-field>
                <mat-label>Hora Inicio</mat-label>
                <input
                  matInput
                  [ngxTimepicker]="pickerHS"
                  formControlName="startTime"
                  required
                  [disabled]="
                    isDisabled || rentalOrderState == 3 || rentalOrderState == 4
                  "
                />
                <ngx-material-timepicker #pickerHS></ngx-material-timepicker>
              </mat-form-field>
            </div>
          </div>

          <div class="default-row">
            <div class="row-item">
              <combos
                [configuration]="combosConfigReceives"
                [reloadCombo]="reloadComboReceives"
                [required]="true"
                [filter]="true"
                [control]="formRO.get('userReceivesId')"
                [disabled]="isDisabled || rentalOrderState == 4"
              >
              </combos>
            </div>

            <div class="row-item">
              <mat-form-field>
                <mat-label>Fecha Fin</mat-label>
                <input
                  [matDatepicker]="pickerFin"
                  autocomplete="off"
                  matInput
                  required
                  formControlName="endDate"
                  [disabled]="isDisabled || rentalOrderState == 4"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerFin">
                </mat-datepicker-toggle>
                <mat-datepicker
                  #pickerFin
                  [touchUi]="movil ? true : false"
                ></mat-datepicker>
                <mat-error>Campo requerido</mat-error>
              </mat-form-field>
            </div>

            <div class="row-item">
              <mat-form-field>
                <mat-label>Hora Fin</mat-label>
                <input
                  matInput
                  [ngxTimepicker]="pickerHE"
                  formControlName="endTime"
                  required
                  [disabled]="isDisabled || rentalOrderState == 4"
                />
                <ngx-material-timepicker #pickerHE></ngx-material-timepicker>
              </mat-form-field>
            </div>
          </div>

          <div class="default-row">
            <div class="row-item">
              <mat-form-field>
                <input
                  autocomplete="off"
                  type="text"
                  formControlName="comment"
                  matInput
                  #comentario
                  maxlength="255"
                  placeholder="Comentario"
                  [disabled]="isDisabled"
                />
                <mat-hint>{{ comentario.value.length }}/255</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div
          style="flex: 0.2"
          *ngIf="
            data.action == 'edit' &&
            rentalOrderState != 5 &&
            rentalOrderState != 1
          "
        >
          <button
            mat-mini-fab
            color="warn"
            type="button"
            (click)="saveRentalEquipment()"
          >
            <mat-icon>save</mat-icon>
          </button>
        </div>
      </div>

      <div
        *ngIf="!disbledEquipment"
        style="display: flex; flex-direction: row; justify-content: center"
      >
        <button
          [disabled]="buttonActive || isDisabled"
          type="submit"
          style="width: 70%; margin-top: 30px; align-self: center"
          color="primary"
          class="button-save mat-elevation-z5"
          mat-raised-button
        >
          Continuar
        </button>
      </div>
    </cdk-virtual-scroll-viewport>
  </form>
</ng-template>
